﻿export class booking_information_token {
    public server: string | null = null;
    public access_token: string | null = null;
    public refresh_token: string | null = null;
}